import { Box, Button, TextField, Divider, Modal, Typography, useTheme } from "@mui/material"
import ListComponent from "../Templates/ListComponent"
import AddIcon from '@mui/icons-material/Add';
import { useState } from "react"
import { useUserContext } from "../../context/UserContext"

const Profile = (props) => {
    const theme = useTheme()
    const { userDetails } = useUserContext()
    const [open, setOpen] = useState(false);
    const apiColumns = [
        {label: 'Created', id: 'created'},
        {label: 'User', id: 'user'},
        {label: 'Label', id: 'label'},
        {label: 'API Key', id: 'apiKey'}
    ]

    const handleClose = () => {
        setOpen(false);
    }

    const [apiKeys, setApiKeys] = useState([
        {created: '18/03/2025, 03:55 pm', user: 'John Doe', label: 'example-api', apiKey: '6c8lpl0xx2f23bue9exame'}
    ]) 

    const [formData, setFormData] = useState({
        created: '',
        user: 'vecros',
        label: '',
        apiKey: ''
    })

    const handleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value})
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const randomAPIKey = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        const formattedDate = new Date().toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
        const newApiKey = {
            ...formData,
            created: formattedDate,
            apiKey: randomAPIKey
        }
        setApiKeys([...apiKeys, newApiKey])
        handleClose();
    }

    const modalStyle = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 700,
        bgcolor: theme.palette.primary.main,
        boxShadow: theme.shadows[5],
        color: theme.palette.text.primary,
        borderRadius: 1,
        p: 3,
    };

    return (
        <Box sx={{
            margin: '50px 200px',
            textAlign: 'left'
        }}>
            <Typography sx={{
                color: theme.palette.text.color,
                fontSize: '32px'
            }}>My Profile</Typography>
            <Divider sx={{ background: theme.palette.border.color }} />
            <Box sx={{
                margin: '10px 0px'
            }}>
                <Typography sx={{
                    color: theme.palette.text.color,
                    fontSize: '24px',
                    margin: '20px 0px'
                }}>Personal Information</Typography>
                <Box sx={{
                    width: '100%',
                    display: 'flex',
                }}>
                    <Typography sx={{
                        color: theme.palette.secondaryText.color,
                        fontSize: '18px',
                        width: '40%'
                    }}>Name:</Typography>
                    <Typography sx={{
                        color: theme.palette.text.color,
                        fontSize: '18px',
                    }}>
                        {userDetails?.user_first_name
                            ? `${userDetails.user_first_name} ${userDetails.user_last_name ?? ""}`.trim()
                            : props.userDetails?.username?.split('@')[0]}
                    </Typography>
                </Box>
                <Box sx={{
                    width: '100%',
                    display: 'flex',
                }}>
                    <Typography sx={{
                        color: theme.palette.secondaryText.color,
                        fontSize: '18px',
                        width: '40%'
                    }}>Email:</Typography>
                    <Typography sx={{
                        color: theme.palette.text.color,
                        fontSize: '18px',
                    }}>
                        {userDetails?.user_email ?? props.userDetails?.username}
                    </Typography>
                </Box>
            </Box>
            <Divider sx={{ background: theme.palette.border.color }} />
            <Box sx={{
                margin: '10px 0px'
            }}>
                <Box sx={{
                    margin: '20px 0px'
                }}>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '100%'
                    }}>
                        <Typography sx={{
                            color: theme.palette.text.color,
                            fontSize: '24px',
                        }}>Your API keys</Typography>
                        <Button sx={{
                            backgroundColor: '#006bce',
                            color: '#fff',
                            textTransform: 'none'
                        }}
                        onClick={() => setOpen(true)}
                        startIcon={<AddIcon />}
                        >Create A key</Button>
                    </Box>
                    <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <Box sx={modalStyle}>
                            <Typography id="modal-modal-title" variant="h6" mb={2}>
                                Name New API Key
                            </Typography>
                            <Typography>
                            Before you start, keep in mind:
                            <ul>
                                <li>You’ll only be able to see the full API Key immediately after you generate it. After that, you won’t see the actual key, only the name you’ve given it.</li>
                                <li>For your security, never share your API Key with a third party.</li>
                                <li>By generating an API Key, you agree to Vecro’s <span style={{
                                    color: '#006bce',
                                    textDecoration: 'underline'
                                }}>API Use Policy.</span></li>
                            </ul>
                            </Typography>
                            <form onSubmit={handleSubmit}>
                                <TextField
                                    fullWidth
                                    label="API Key Name"
                                    name="label"
                                    value={formData.label}
                                    onChange={handleChange}
                                    margin="normal"
                                    required
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            "&:hover fieldset": {
                                                borderColor: "white !important", // Added !important here too
                                            },
                                            "&.Mui-focused fieldset": {
                                                borderColor: "white !important", // Same here
                                            },
                                        },
                                        "& .MuiInputLabel-root": {
                                            color: "white !important", // Ensures label color is also white
                                        },
                                        "& .MuiInputLabel-root.Mui-focused": {
                                            color: "white !important", // Ensures white color on focus
                                        },
                                        input: { color: "white" }, // Ensures input text color is white
                                    }}
                                />
                                <Typography sx={{
                                    opacity: '0.7'
                                }}>Tip: choose a descriptive name, so you know which application uses that key.</Typography>
                                <Button type="submit" variant="contained"fullWidth sx={{ mt: 2, textTransform: 'none', backgroundColor: '#006bce' }}>
                                    Generate a key
                                </Button>
                            </form>
                        </Box>
                    </Modal>
                    <Typography sx={{
                        color: theme.palette.text.color
                    }}>You can review, revoke or generate new API keys below. <br />
                    <span style={{
                        textDecoration: 'underline',
                        color: '#006BCE'
                    }}>Learn more about generating, revoking, and accessing API keys here.</span></Typography>
                </Box>
                <ListComponent
                    columns={apiColumns}
                    data={apiKeys}
                />
            </Box>
        </Box>
    )
}

export default Profile